import Breadcrumb from "@/components/feature/Breadcrumb";

function AboutHeader() {
  return (
    <section className="border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "关于我们" }]} />
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-news-line"></i> 关于我们
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            为读懂嘿咻嘿咻漫画而生
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们是一群热爱故事、也热爱较真的追更人。从剧情解析到角色档案，从读者口碑到创作手记，本站希望成为嘿咻嘿咻漫画读者最顺手的信息与讨论空间。
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutHeader;